(() => {
  if (customElements.get('shop-by-category')) return;
  customElements.define('shop-by-category', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-track]');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const rtl = getComputedStyle(this).direction === 'rtl';
        this.move((event.key === 'ArrowRight') !== rtl ? 1 : -1);
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('.shop-category__item');
        if (item) item.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    update() {
      const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
      this.previous.hidden = this.next.hidden = this.track.children.length < 2;
      this.previous.disabled = this.next.disabled = !overflow;
      this.track.tabIndex = overflow ? 0 : -1;
    }
    move(direction) {
      const rtl = getComputedStyle(this).direction === 'rtl';
      const max = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      const step = this.track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
      let target = position + step * direction;
      if (direction > 0 && position >= max - 2) target = 0;
      if (direction < 0 && position <= 2) target = max;
      this.track.scrollTo({
        left: Math.max(0, Math.min(max, target)) * (rtl ? -1 : 1),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
})();